import Local from './ConfigurationLocal';
import Int from './ConfigurationInt';
import Dogfood from './ConfigurationDogfood';
import Prod from './ConfigurationProd';

const getConfig = () => {
    const envProcessEnvironementValue: string = process.env.REACT_APP_ENV !== undefined ? process.env.REACT_APP_ENV : 'ENVIRONMENT_VARIABLE_NOT_SET';
    if (envProcessEnvironementValue === 'local')
    {
        return Local;
    }
    else if (envProcessEnvironementValue === 'int')
    {
        return Int;
    }
    else if (envProcessEnvironementValue === 'dogfood')
    {
        return Dogfood;
    }
    else if (envProcessEnvironementValue === 'prod')
    {
        return Prod;
    }
    else{
        throw new Error(`Invalid value for REACT_APP_ENV: ${envProcessEnvironementValue}`);
    }
}

export const envConfig = getConfig();